module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_4_3_w_1534.c0bfc28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_1534.jpg
// module id = 0hMP
// module chunks = 0